/**
 * Custom Form Component
 * Extends Ant Design Form with custom styling
 */

import { Form as AntForm, FormProps as AntFormProps, FormItemProps } from 'antd';
import classNames from 'classnames';
import { ReactNode } from 'react';
import './CustomForm.scss';

export interface CustomFormProps extends Omit<AntFormProps, 'variant'> {
  /** Form variant */
  formVariant?: 'default' | 'inline' | 'horizontal';
  /** Form children */
  children?: ReactNode;
}

/**
 * CustomForm Component
 */
const CustomFormComponent: React.FC<CustomFormProps> = ({
  formVariant = 'default',
  className,
  children,
  ...rest
}) => {
  const formClasses = classNames('custom-form', `custom-form--${formVariant}`, className);

  return <AntForm {...rest} className={formClasses}>{children}</AntForm>;
};

/**
 * CustomFormItem Component
 */
export const CustomFormItem: React.FC<FormItemProps> = ({ className, ...rest }) => {
  const itemClasses = classNames('custom-form-item', className);
  return <AntForm.Item {...rest} className={itemClasses} />;
};

// Create a compound component
export const CustomForm = Object.assign(CustomFormComponent, {
  Item: CustomFormItem,
  List: AntForm.List,
  useForm: AntForm.useForm,
  Provider: AntForm.Provider,
});

export default CustomForm;

